import { VueCookies as Cookie } from 'vue-cookies';
import { throttle } from 'lodash';
import { errorHandler } from 'services/logger';
import { baseApi, configRetryRefresh, isCancel } from 'core/api/baseApi';
import { useUserStore } from 'store/modules';

const maxAge = 10000;

let refreshTokenPromise = null;

const logout = async () => {
    if (sessionStorage.getItem('assume_token')) {
        window.close();

        return;
    }

    Cookie.set('salesmessage-user-logout', '1d');
    Cookie.remove('salesmessage-token');
    localStorage.removeItem('token');

    await useUserStore().loggingOut();

    window.location = '/';
};

const refreshToken = async () => {
    try {
        const response = await useUserStore().updateAuthRefresh();

        if (response.is_login === false) {
            await logout();
        }
    } catch (e) {
        console.error(e);
    } finally {
        refreshTokenPromise = null;
    }
};

const handleRefreshToken = () => {
    if (refreshTokenPromise) {
        return refreshTokenPromise;
    }

    refreshTokenPromise = refreshToken();

    return refreshTokenPromise;
};

const handleLogout = async () => {
    window.localStorage.removeItem('isAwayCounter');

    try {
        if (sessionStorage.getItem('assume_token')) {
            window.close();

            return;
        }

        window.location.reload()
    } catch (e) {
        console.error(e);
    }
};

const throttleHandleLogout = throttle(handleLogout, maxAge, { trailing: false });

export const rejectRefreshToken = async (data) => {
    const response = data.response;
    const authRequired = response?.data?.auth_required;
    const isRefresh = authRequired === true;
    const isLogout = authRequired === false;

    if (data?.config?.url?.includes('logger/v1/logs')) {
        return Promise.reject(data);
    }

    if (!isCancel(data) && !data?.config?.url?.includes('segment/v1/events')) {
        errorHandler(data);
    }

    if (configRetryRefresh.count >= configRetryRefresh.max) {
        await useUserStore().updateAuthLogout();
        await logout();

        return Promise.reject(data);
    }

    if (isRefresh) {
        await handleRefreshToken();

        configRetryRefresh.count += 1;

        return baseApi.request(data.config);
    }

    if (isLogout) {
        await throttleHandleLogout();
    }

    return Promise.reject(data);
};
